import { render, staticRenderFns } from "./settings-page.vue?vue&type=template&id=887e1d3a&"
import script from "./settings-page.vue?vue&type=script&lang=js&"
export * from "./settings-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports